import {
  useHiddenSidebarMenus,
  useSetSidebarMenuVisibility,
} from "../../hooks/sidebar-menu.hooks";
import {
  TSidebarMenuKey,
  TSidebarRole,
} from "../CommonComponents/Navbar/sidebar/sidebarMenuVisibility";
import { SuccessToast } from "../toastMessage";
import style from "./SidebarMenuConfig.module.css";

type Props = {
  role: TSidebarRole;
  menuKey: TSidebarMenuKey;
  /** The entry's name, used in the confirmation shown after a change. */
  menuLabel: string;
};

/**
 * The on/off switch for one sidebar entry of one role. On means the role is
 * shown the entry. It knows only "a role and an entry", so the Admin screen
 * can lay any number of them out in a grid.
 */
export default function SidebarMenuToggle({ role, menuKey, menuLabel }: Props) {
  const { data: hidden, isLoading } = useHiddenSidebarMenus();
  const { mutate: setVisibility, isPending } = useSetSidebarMenuVisibility();

  const isShown = !(hidden?.[role] ?? []).includes(menuKey);

  const onToggle = () =>
    setVisibility(
      { role, menuKey, visible: !isShown },
      {
        onSuccess: () =>
          SuccessToast(
            isShown
              ? `${menuLabel} is now hidden from ${role}`
              : `${menuLabel} is now shown to ${role}`
          ),
      }
    );

  return (
    <label className={style.toggleBtn}>
      <input
        type="checkbox"
        className={style.inputCheckbox}
        checked={isShown}
        disabled={isLoading || isPending}
        onChange={onToggle}
      />
      <span className={style.slider}></span>
    </label>
  );
}
